var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table__th"},[_vm._v(" "+_vm._s(_vm.tHeader.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }